var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass:
          "form-field form-field--stretch form-field--style-1 form-field--no-asterisk col",
      },
      [
        _c("div", { staticClass: "input-with-icon" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.dataFiltersLocation,
                expression: "dataFiltersLocation",
              },
            ],
            staticClass: "form-control",
            attrs: {
              id: "location",
              type: "text",
              name: "location",
              autocomplete: "off",
              tabindex: "1",
              "data-select-typeahead": "",
              placeholder: _vm.$t("messages_nl.search-form.location"),
            },
            domProps: { value: _vm.dataFiltersLocation },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.dataFiltersLocation = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-search" }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }